var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20C16 19.4477 15.5523 19 15 19C14.4477 19 14 19.4477 14 20V30C14 30.5523 14.4477 31 15 31C15.5523 31 16 30.5523 16 30V20Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20C18 19.4477 18.4477 19 19 19C19.5523 19 20 19.4477 20 20V30C20 30.5523 19.5523 31 19 31C18.4477 31 18 30.5523 18 30V20Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20C24 19.4477 23.5523 19 23 19C22.4477 19 22 19.4477 22 20V30C22 30.5523 22.4477 31 23 31C23.5523 31 24 30.5523 24 30V20Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20C26 19.4477 26.4477 19 27 19C27.5523 19 28 19.4477 28 20V30C28 30.5523 27.5523 31 27 31C26.4477 31 26 30.5523 26 30V20Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20C32 19.4477 31.5523 19 31 19C30.4477 19 30 19.4477 30 20V30C30 30.5523 30.4477 31 31 31C31.5523 31 32 30.5523 32 30V20Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 20C34 19.4477 34.4477 19 35 19C35.5523 19 36 19.4477 36 20V30C36 30.5523 35.5523 31 35 31C34.4477 31 34 30.5523 34 30V20Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19C15 18.4477 14.5523 18 14 18C13.4477 18 13 18.4477 13 19V29C13 29.5523 13.4477 30 14 30C14.5523 30 15 29.5523 15 29V19Z",
    fill: "#011E29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12C44 9.5 42.5 8 40 8H35C34.4477 8 34 8.44772 34 9C34 9.55228 34.4464 10 34.9987 10C36.4697 10 39.1378 10 40 10C41.25 10 42 10.7545 42 12C42 12.8842 42 15.5368 42 17.0014C42 17.5537 42.4477 18 43 18C43.5523 18 44 17.5523 44 17V12Z",
    fill: "#011E29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 36C4 38.5 5.5 40 8 40H13C13.5523 40 14 39.5523 14 39C14 38.4477 13.5539 38 13.0017 38C11.5868 38 9.05351 38 8 38C6.5 38 6 37.5 6 36C6 34.9465 6 32.4132 6 30.9983C6 30.4461 5.55228 30 5 30C4.44772 30 4 30.4477 4 31V36Z",
    fill: "#011E29"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36C44 38.5 42.5 40 40 40H35C34.4477 40 34 39.5523 34 39C34 38.4477 34.4461 38 34.9983 38C36.4132 38 38.9465 38 40 38C41.75 38 42 37.25 42 36C42 34.9465 42 32.4132 42 30.9983C42 30.4461 42.4477 30 43 30C43.5523 30 44 30.4477 44 31V36Z",
    fill: "#011E29"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19C17 18.4477 17.4477 18 18 18C18.5523 18 19 18.4477 19 19V29C19 29.5523 18.5523 30 18 30C17.4477 30 17 29.5523 17 29V19Z",
    fill: "#011E29"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19C23 18.4477 22.5523 18 22 18C21.4477 18 21 18.4477 21 19V29C21 29.5523 21.4477 30 22 30C22.5523 30 23 29.5523 23 29V19Z",
    fill: "#011E29"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19C25 18.4477 25.4477 18 26 18C26.5523 18 27 18.4477 27 19V29C27 29.5523 26.5523 30 26 30C25.4477 30 25 29.5523 25 29V19Z",
    fill: "#011E29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19C31 18.4477 30.5523 18 30 18C29.4477 18 29 18.4477 29 19V29C29 29.5523 29.4477 30 30 30C30.5523 30 31 29.5523 31 29V19Z",
    fill: "#011E29"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19C33 18.4477 33.4477 18 34 18C34.5523 18 35 18.4477 35 19V29C35 29.5523 34.5523 30 34 30C33.4477 30 33 29.5523 33 29V19Z",
    fill: "#011E29"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 9.5 5.5 8 8 8H13C13.5523 8 14 8.44772 14 9C14 9.55228 13.5536 10 13.0013 10C11.5303 10 8.86224 10 8 10C6.75 10 6 10.7545 6 12C6 12.8842 6 15.5368 6 17.0014C6 17.5537 5.55228 18 5 18C4.44772 18 4 17.5523 4 17V12Z",
    fill: "#011E29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarCode);
export default __webpack_public_path__ + "static/media/bar-code.0f101b314670dbe850a7b61e8edd8e0b.svg";
export { ForwardRef as ReactComponent };